import { render, staticRenderFns } from "./GaleriaProductos.vue?vue&type=template&id=39f2bf08&scoped=true&"
import script from "./GaleriaProductos.vue?vue&type=script&lang=js&"
export * from "./GaleriaProductos.vue?vue&type=script&lang=js&"
import style0 from "./GaleriaProductos.vue?vue&type=style&index=0&id=39f2bf08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2bf08",
  null
  
)

export default component.exports